module.exports = __webpack_public_path__ + "img/logo.c25b4ad4.png";